import {css} from 'lit';
export const styles = css`h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  font-size: inherit;
  font-weight: inherit;
  line-height: 1.3;
}

p:last-child {
  margin-bottom: 0;
}

button {
  cursor: pointer;
}
`;
export default styles;
